import { ChipType } from "./MListaChips.type"
import { computed } from "vue"

export function setup(Props: { exibirSomente: number; chips: string[] }) {
  const propExibirSomenteValido = computed(() => {
    if (Props.exibirSomente >= Props.chips.length) {
      return 0
    }
    return Props.exibirSomente
  })
  const numeroDeChipsAMais = computed(() => {
    return "+" + (Props.chips.length - propExibirSomenteValido.value)
  })
  const chipsVisiveis = computed(() => {
    if (!propExibirSomenteValido.value) {
      return Props.chips
    }
    return Props.chips.slice(0, propExibirSomenteValido.value)
  })

  return {
    chipsVisiveis,
    numeroDeChipsAMais,
    propExibirSomenteValido,
  }
}
